import { render } from "./GetBandsSection.vue?vue&type=template&id=378790e6&ts=true"
import script from "./GetBandsSection.vue?vue&type=script&lang=ts"
export * from "./GetBandsSection.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\e394cd1ec4c7054f\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__